export default __webpack_public_path__ + "static/media/collection-img-sample4.feb6725b.png";